import styled from 'styled-components';

import {
  TextField,
  Button,
  FormControlLabel,
  Switch,
} from '@mui/material';
import colors from '../../../../../styles/colors';
import { Title as BaseTitle } from '../../styles';

const ContentWrapper = styled.div`
  padding: 16px;
  height: 100%;
  width: 60%;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  background-color: ${colors.base.gamma};
`;

const MessageContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 75%;
`;

const StyledTextField = styled(TextField)`
  width: 100%;
`;

const StyledButton = styled(Button)`
  margin: 10px 0;
  width: 250px;
  text-transform: none;
`;

const StepToggle = styled(FormControlLabel)`
  margin: 0 0 10px;
`;

const StepToggleSwitch = styled(Switch)``;

const Step2Title = styled(BaseTitle)`
  margin-top: 15px;
`;

export {
  ContentWrapper,
  InputContainer,
  StyledTextField,
  StyledButton,
  MessageContainer,
  StepToggle,
  StepToggleSwitch,
  Step2Title,
};
